// 15.F freemium: экран-замок вместо детальных находок до оплаты. Заказчик
// видит ЦИФРУ (сколько нашли) бесплатно, а сами находки — после оплаты тарифа.
import { Lock } from 'lucide-react';

export function FindingsLock({ title, count, onPay }: {
  title: string;
  count: number | null;      // сколько замечаний нашли (из readiness-summary); null — ещё не проверяли
  onPay: () => void;
}) {
  const notChecked = count === null;
  return (
    <div className="rounded-card" style={{ padding: '40px 32px', background: '#FFF', border: '1px solid #E5E7EB', textAlign: 'center' }}>
      <div className="mx-auto rounded-pill flex items-center justify-center" style={{ width: 60, height: 60, background: 'rgba(245,158,11,.10)', marginBottom: 18 }}>
        <Lock size={26} stroke="#B45309" />
      </div>
      <div className="text-muted uppercase tracking-wider" style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.05em' }}>{title}</div>
      {notChecked ? (
        <h4 className="font-heading text-ink" style={{ fontSize: 18, fontWeight: 650, marginTop: 8 }}>
          Проверка ещё не запускалась
        </h4>
      ) : count === 0 ? (
        <h4 className="font-heading" style={{ fontSize: 18, fontWeight: 650, marginTop: 8, color: '#059669' }}>
          Замечаний не найдено
        </h4>
      ) : (
        <h4 className="font-heading text-ink" style={{ fontSize: 22, fontWeight: 700, marginTop: 8 }}>
          Найдено замечаний: {count}
        </h4>
      )}
      <p className="text-muted mx-auto" style={{ fontSize: 13.5, lineHeight: 1.6, marginTop: 10, maxWidth: 460 }}>
        {notChecked
          ? 'Запустите проверки на вкладке «Оценка готовности» — это бесплатно. Затем оплатите тариф, чтобы увидеть детали найденного.'
          : 'Оплатите тариф, чтобы открыть детали: где именно, по какому требованию/норме и с цитатой из документа.'}
      </p>
      {!notChecked && (
        <button type="button" onClick={onPay} className="inline-flex items-center rounded-pill"
          style={{ marginTop: 18, gap: 7, padding: '11px 22px', fontSize: 14.5, fontWeight: 700, background: '#F59E0B', color: '#1F1300', border: 'none', cursor: 'pointer' }}>
          Оплатить, чтобы увидеть находки
        </button>
      )}
    </div>
  );
}
